export const aspectRatioMapping = {
	"16:9": "16:9",
	"16:5": "16:5",
	"10:4": "10:4",
	"1:1": "1:1",
	"3:4": "3:4",
	"4:3": "4:3",
};

export const convertAspectRatioMapping = (_aspectRatio, _cloudinaryNamedTransformation) => {
	let aspectRatio;
	let cloudinaryNamedTransformation;

	switch (_aspectRatio) {
		case "16:9":
			aspectRatio = 16 / 9;
			cloudinaryNamedTransformation = _cloudinaryNamedTransformation || "t_VWQ-ar16_9";
			break;
		case "16:5":
			aspectRatio = 16 / 5;
			cloudinaryNamedTransformation = _cloudinaryNamedTransformation || "t_VWQ-ar16_5";
			break;
		case "10:4":
			aspectRatio = 10 / 4;
			cloudinaryNamedTransformation = _cloudinaryNamedTransformation || "t_VWQ-ar10_4";
			break;
		case "1:1":
			aspectRatio = 1;
			cloudinaryNamedTransformation = _cloudinaryNamedTransformation || "t_VWQ-ar1_1";
			break;
		case "3:4":
			aspectRatio = 3 / 4;
			cloudinaryNamedTransformation = _cloudinaryNamedTransformation || "t_VWQ-ar3_4";
			break;
		default: {
			try {
				const aspectRatioRegex = /^(\d+(?:\.\d+)?):(\d+(?:\.\d+)?)$/;
				const providedAspectRatio = aspectRatioRegex.exec(_aspectRatio);

				if (providedAspectRatio) {
					aspectRatio = providedAspectRatio[1] / providedAspectRatio[2];
				} else {
					aspectRatio = 16 / 5;
				}
			} catch {
				console.warn(`Unable to parse provided aspect ratio: ${_aspectRatio}`);
				aspectRatio = 16 / 5;
			}

			cloudinaryNamedTransformation = _cloudinaryNamedTransformation || "t_VWQ-ar16_5";
			break;
		}
	}

	return [aspectRatio, cloudinaryNamedTransformation];
};
